// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from './context/CartContext';

// --- INÍCIO DA CORREÇÃO DEFINITIVA: IMPORTAÇÕES DO AG GRID ---
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';

// 1. Importa os estilos separadamente
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// 2. Registra apenas os módulos essenciais da Community Edition
ModuleRegistry.registerModules([ ClientSideRowModelModule ]);
// --- FIM DA CORREÇÃO ---

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* 2. ENVOLVA TUDO AQUI */}
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter> {/* 3. FECHE A TAG AQUI */}
  </React.StrictMode>
);

reportWebVitals();